import { z } from 'zod/v3';

import { InvoicesRequestParams } from '../api-types';

const nonInventoryInvoicesFiltersSchema = z.object({
  statuses: z.custom<InvoicesRequestParams['statuses']>().optional(),
  countryCodes: z.custom<InvoicesRequestParams['countryCodes']>().optional(),
  earliestInvoiceDate: z.string().optional(),
  latestInvoiceDate: z.string().optional(),
  earliestReceivedAt: z.string().optional(),
  latestReceivedAt: z.string().optional(),
});

const nonInventoryInvoicesSearchParamsSchema = z.object({
  page: z.coerce.number().optional(),
  pageSize: z.coerce.number().optional(),
  q: z.coerce.string().optional(),
});

export const nonInventoryInvoicesRouteSearchSchema = z.object({
  ...nonInventoryInvoicesFiltersSchema.shape,
  ...nonInventoryInvoicesSearchParamsSchema.shape,
});

export type NonInventoryInvoicesFilters = z.infer<typeof nonInventoryInvoicesFiltersSchema>;
